<template>
  <v-app>
    <div>
      <div @click="categoryFnHandler" style="margin-top: 4px">
        <!-- <MultiSelectObject :propsData="categoryList" boxName="Category" /> -->
        <CategorySelect :propsData="categoryList" boxName="Category" />
      </div>
      <div @click="subCategoryFnHandler">
        <SubCategorySelect
          :propsData="subcategoryList"
          boxName="Sub Category"
        />
        <!-- <MultiSelectObject
          :propsData="subcategoryList"
          clearable
          boxName="Sub Category"
        /> -->
      </div>
      <v-checkbox
        label="Primary"
        value="Primary"
        @click="convertSelectToJson"
      ></v-checkbox>
      <div @click="subsubCategoryFnHandler">
        <!-- <MultiSelectObject
          :propsData="subsubCategory"
          boxName="Sub Sub Category"
        /> -->
        <SubSubCategorySelect
          v-show="!subsubCategoryRole"
          :propsData="subsubCategory"
          boxName="Sub Sub Category"
        />
      </div>
      <v-checkbox
        v-if="creditOptionFlagOn()"
        label="Reloadable"
        value="Reloadable"
        @click="convertSelectToJson"
      ></v-checkbox>
      <SelectBox
        v-if="CreditComboFn() || ifMortageSelected()"
        :label="`Application Type`"
        :propsData="applicationType"
        boxName="Application Type"
      ></SelectBox>
      <SelectBox
        v-if="CreditComboFn()"
        :label="`Introductory Pricing`"
        :propsData="IntroductoryPricing"
        boxName="Introductory Pricing"
      ></SelectBox>
      <SelectBox
        v-if="insuranceBoxFlag()"
        :label="`Issue Type`"
        :propsData="issueType"
        boxName="Issue Type"
      ></SelectBox>
      <SelectBox
        v-if="mailingBoxFlag() || audianceInsuranceBoxFlag()"
        :label="`Mailing Type`"
        :propsData="mailingTypeData"
        boxName="Mailing Type"
      >
      </SelectBox>
      <v-checkbox
        v-if="mailingBoxFlag() || audianceInsuranceBoxFlag()"
        label="Not"
        value="Not1"
        @click="convertSelectToJson"
      ></v-checkbox>

      <!-- <RadioButton
        v-if="PersonalizedFlag()"
        :label="['Personalized', 'Non-Personalized', 'Both']"
      ></RadioButton> -->
      <v-radio-group
        inline
        hide-details
        v-model="personalizedSelection"
        @update:modelValue="updateRadioValues"
      >
        <v-radio label="Personalized" value="1"></v-radio>
        <v-radio label="Non-Personalized" value="2"></v-radio>
        <v-radio label="Both" value="3"></v-radio>
      </v-radio-group>
      <VerticalSpacer :space="1"></VerticalSpacer>

      <SelectBox
        v-show="consumerBoxFlag() || !businessContentRoleVisibility"
        :propsData="businessContentData"
        boxName="Business Content"
      ></SelectBox>
      <SelectBox
        v-show="consumerBoxFlag() || !dmaRoleVisibility"
        :label="`DMA®`"
        :propsData="dmaData"
        boxName="DMA®"
      ></SelectBox>
      <SelectBox
        v-if="ifEnergySelected()"
        :label="`EDC / LDC / TDSP`"
        :propsData="energyEDC"
        boxName="EDC / LDC / TDSP"
      >
      </SelectBox>
      <SelectBox
        :label="`State/Province`"
        :propsData="usaStatesAPI"
        boxName="State/Province"
      ></SelectBox>

      <SelectBox
        v-if="consumerBoxFlag()"
        :label="`Age`"
        :propsData="ageData"
        boxName="Age"
      ></SelectBox>
      <SelectBox
        v-if="consumerBoxFlag()"
        :label="`Income`"
        :propsData="incomeData"
        boxName="Income"
      ></SelectBox>
      <SelectBox
        v-if="consumerBoxFlag()"
        :label="`Income Producing Assets Segment Code *R*`"
        :propsData="IncomeProducingAssetsSegCodeData"
        boxName="Income Producing Assets Segment Code *R*"
      ></SelectBox>
      <div v-show="consumerBoxFlag() && !valueScore">
        <SelectBox
          :label="`Value Score`"
          :propsData="valueScoreData"
          boxName="Value Score"
        >
        </SelectBox>
      </div>

      <SelectBox
        v-show="!ficoFieldRolebased"
        :label="`FicoScore`"
        :propsData="FICOCreditVantage"
        boxName="FicoScore"
      ></SelectBox>
      <SelectBox
        v-show="!creditVisionRolebased"
        :label="`CreditVision`"
        :propsData="FICOCreditVantage"
        boxName="CreditVision"
      ></SelectBox>
      <SelectBox
        v-show="!vantageScoreRolebased"
        :label="`VantageScore`"
        :propsData="FICOCreditVantage"
        boxName="VantageScore"
      ></SelectBox>
      <DropDownEvent
        boxName1="Worksite/Voluntary"
        boxName2="Non-Worksite/Voluntary"
        @dropsEventsChanges="dropsEventsChanges"
        @click="convertSelectToJson"
      />
      <DropDownEvent
        boxName1="Credit Union"
        boxName2="Non-Credit Union"
        @dropsEventsChanges="dropsEventsChanges"
        @click="convertSelectToJson"
      />
      <DropDownEvent
        v-show="!affinionRoleVisibility"
        class="custom-checkbox"
        boxName1="Affinity/Association"
        boxName2="Non-Affinity/Association"
        @dropsEventsChanges="dropsEventsChanges"
        @click="convertSelectToJson"
      />
      <v-select
        v-if="affinityBoxHandler()"
        v-model="affinityCatSelection"
        label="Affinity/Association Category"
        density="compact"
        variant="outlined"
        item-title="AffinityCategoryName"
        item-value="AffinityCategoryID"
        return-object="true"
        multiple
        @update:modelValue="affinityClickHandler1"
        :items="sortData(affinityCatDropdown)"
      ></v-select>
      <v-select
        v-if="affinityBoxHandler()"
        label="Affinity/Association Sub-Category"
        v-model="affinitySubCatSelection"
        density="compact"
        variant="outlined"
        item-title="AffinityCategoryName"
        item-value="AffinityCategoryID"
        return-object
        multiple
        :items="sortData(affinitySubCatSlicedDropdown)"
      ></v-select>
      <v-checkbox
        v-if="creditOptionFlagOn() || BankCreditComboFn()"
        label="Rewards"
        v-model="rewardCheckbox"
        density="compact"
        @click="rewardsBoxHandler"
      >
      </v-checkbox>
      <v-select
        v-if="
          rewardProgBoxFlag && (creditOptionFlagOn() || BankCreditComboFn())
        "
        label="Rewards Program Emphasis"
        v-model="rewardsProgVariable"
        density="compact"
        variant="outlined"
        item-title="RewardTypeName"
        item-value="RewardTypeID"
        multiple
        :items="rewardProgBoxData"
      ></v-select>

      <v-checkbox
        label="Incentive"
        density="compact"
        v-model="incentiveModel"
        @click="convertSelectToJson"
      >
      </v-checkbox>
      <v-checkbox
        v-show="!RxRoleVisibility"
        label="Rx"
        density="compact"
        value="Rx"
        @click="convertSelectToJson"
      >
      </v-checkbox>
      <v-checkbox
        label="Affinion"
        density="compact"
        value="Affinion"
        @click="convertSelectToJson"
      >
      </v-checkbox>
      <div v-show="insuranceBoxFlag() && !CDHPHDHPHSA">
        <v-checkbox
          label="CDHP/HDHP/HSA"
          density="compact"
          value="CDHP/HDHP/HSA"
          @click="convertSelectToJson"
        >
        </v-checkbox>
      </div>
      <DropDownEvent
        v-show="!preScreenOptOut"
        boxName1="Pre-Screen/Opt-Out"
        boxName2="Non-Pre-Screen/Opt-Out"
        @dropsEventsChanges="dropsEventsChanges"
        @click="convertSelectToJson"
      />
      <DropDownEvent
        boxName1="Retail Card Study"
        boxName2="Non-Retail Card Study"
        @dropsEventsChanges="dropsEventsChanges"
        @click="convertSelectToJson"
      />
      <v-checkbox
        v-show="TravelRetailBoxFlagHandler()"
        label="Credit Card Mentioned"
        density="compact"
        value="CreditCardMentioned"
        @click="convertSelectToJson"
      >
      </v-checkbox>
      <v-checkbox
        label="Target Markets"
        density="compact"
        @update:modelValue="targetMarketHandler"
        value="TargetMarkets"
        @click="convertSelectToJson"
      >
      </v-checkbox>
      <SelectBox
        v-if="targetMarketCountriesBoxFlag"
        :label="`Target Markets`"
        :propsData="targetCountriesDropdown"
        boxName="Target Markets"
      ></SelectBox>

      <DropDownEvent
        v-show="!FeeProductRoleVisibility"
        boxName1="Fee Product"
        boxName2="Ancillary Service - No Fee"
        @dropsEventsChanges="dropsEventsChanges"
        @click="convertSelectToJson"
      />
      <v-checkbox
        label="Faux Check"
        density="compact"
        value="FauxCheck"
        @click="convertSelectToJson"
      />
      <SelectBox
        :propsData="ancillary_product"
        @click="getdata()"
        boxName="Ancillary Products"
      />
      <DropDownEvent
        v-if="ifMortageSelected()"
        boxName1="Refinance"
        boxName2="Non-Refinance"
        @dropsEventsChanges="dropsEventsChanges"
        @click="convertSelectToJson"
      />
      <v-checkbox
        v-if="ifMortageSelected()"
        label="Jumbo/Non-Conforming"
        density="compact"
        v-model="jumbo_ncnfgModel"
        @click="convertSelectToJson"
      >
      </v-checkbox>
      <v-checkbox
        v-if="ifMortageSelected()"
        label="VA"
        density="compact"
        v-model="vaModel"
        @click="convertSelectToJson"
      >
      </v-checkbox>
      <v-checkbox
        v-if="ifMortageSelected()"
        label="FHA"
        density="compact"
        v-model="fhaModel"
        @click="convertSelectToJson"
      >
      </v-checkbox>
      <v-checkbox
        v-if="ifMortageSelected()"
        label="Conventional"
        density="compact"
        v-model="conventionalModel"
        @click="convertSelectToJson"
      >
      </v-checkbox>
      <v-checkbox
        v-if="ifMortageSelected()"
        label="USDA"
        density="compact"
        v-model="usdaModel"
        @click="convertSelectToJson"
      >
      </v-checkbox>
      <v-checkbox
        v-if="ifMortageSelected()"
        label="Correspondent Lending"
        density="compact"
        v-model="correspondentLendingModel"
        @click="convertSelectToJson"
      >
        <VerticalSpacer :space="1"></VerticalSpacer>
      </v-checkbox>

      <!-- <v-textarea label="Minimum/Maximum Loan Amount ($)"></v-textarea> -->
      <VerticalSpacer :space="1"></VerticalSpacer>

      <MinMaxSlider v-if="ifMortageSelected()"></MinMaxSlider>
      <SelectBox
        v-if="insuranceBoxFlag()"
        :propsData="ridersData()"
        boxName="Riders"
      />
      <VerticalSpacer :space="1"></VerticalSpacer>
      <SelectBox :propsData="communicationType" boxName="Communication Type" />
      <v-checkbox
        label="Not"
        value="Not"
        @click="convertSelectToJson"
      ></v-checkbox>
      <SelectBox
        v-if="deliveryFlagOnDirect()"
        :label="`Delivery Method`"
        :propsData="deliveryMethod"
        boxName="Delivery Method"
        @submit="onSubmit"
      ></SelectBox>
      <SelectBox
        v-if="dashboardDirectComboFn()"
        :label="`Delivery Type`"
        :propsData="deliveryType"
        boxName="Delivery Type"
        @submit="onSubmit"
      ></SelectBox>
      <SelectBox
        v-if="dashboardDirectComboFn()"
        :label="`Postage`"
        :propsData="postage"
        boxName="Postage"
        @submit="onSubmit"
      ></SelectBox>
      <SelectBox
        v-if="dashboardDirectComboFn()"
        :label="`Pre-Sorted`"
        :propsData="preSorted"
        boxName="Pre-Sorted"
        @submit="onSubmit"
      ></SelectBox>
      <SelectBox
        v-if="dashboardDirectComboFn()"
        :propsData="packageType"
        boxName="Package Type"
        @submit="onSubmit"
      ></SelectBox>
      <!-- <SelectBox
      v-if="dashboardDirectEmailComboFn()"
      :label="`Electronic Type`"
      :propsData="packageType"
      boxName="Electronic Type"
      @submit="onSubmit"
    ></SelectBox> -->
      <div
        v-show="!electronicTypeRoleVisibility && electronicTypeFlagOnEmail()"
      >
        <SelectBox
          v-show="electronicTypeFlagOnEmail()"
          :propsData="electronicType"
          boxName="Electronic Type"
        ></SelectBox>
      </div>
      <SelectBox
        v-if="publicationTypeFlagOnPrint()"
        :label="`Publication Type`"
        :propsData="publicationType"
        boxName="Publication Type"
      ></SelectBox>
      <!-- <v-text-field
        v-if="publicationTypeFlagOnPrint()"
        class="font-weight-medium"
        label="Publication Name"
        variant="outlined"
        density="compact"
      ></v-text-field> -->

      <v-row v-if="publicationTypeFlagOnPrint()">
        <v-col cols="12" v-click-outside="publicationNameclickedOut">
          <div v-for="c in choosenpublicationName" v-bind:key="c.id">
            <v-chip
              class="mr-1 mt-1"
              closable
              @click:close="removepublicationName(c)"
              >{{ c.name }}</v-chip
            >
          </div>
          <v-text-field
            class="font-weight-small"
            variant="outlined"
            density="compact"
            label="Publication Name"
            v-model="publicationName"
            persistent-hint
            style="margin-top: 9px"
          >
          </v-text-field>
          <div style="margin-top: -17px">
            <!-- <v-chip @click.prevent="clearpublicationNameLookupUserEntry"
              >Clear</v-chip
            > -->
            <v-chip @click.prevent="clearpublicationNameLookupAllEntry"
              >Clear All</v-chip
            ><v-chip @click.prevent="publicationNameSelectAll"
              >Select All</v-chip
            ><v-chip @click.prevent="publicationNameShowAll">Show All</v-chip>
          </div>
          <v-progress-linear
            v-if="publicationNameloading"
            indeterminate
            color="primary"
            class="mt-4"
          ></v-progress-linear>
          <v-list max-height="300" outlined class="overflow-y-auto">
            <v-list-item
              v-for="item in publicationNames"
              :key="item.id"
              :value="item"
              @click="choosepublicationName(item)"
              class="overflow-y-auto"
            >
              {{ item.name }}
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>

      <SelectBox :propsData="groupSizes" boxName="Group Size" />
      <VerticalSpacer :space="1"></VerticalSpacer>
      <DropdownList :data="offerOriginData()" boxName="Offer Origin" />
      <DropdownList :data="campaign_language" boxName="Campaign Language" />
      <SelectBox
        v-if="ifEnergySelected()"
        :propsData="energyRateType"
        boxName="Energy - Rate Type"
      />
      <SelectBox
        v-if="ifEnergySelected()"
        :propsData="energyOfferPrice"
        boxName="Offer Price (¢ per kWh)"
      />
      <SelectBox
        v-if="ifEnergySelected()"
        :propsData="energyTerm"
        boxName="Energy - Term Length"
      />
      <v-checkbox
        v-if="ifEnergySelected()"
        label="Cancel Fee"
        density="compact"
        value="CancelFee"
        @click="energyCheckboxex"
      />

      <SelectBox
        v-if="consumerBoxFlag()"
        :label="`Face Amount`"
        :propsData="faceAmntData"
        boxName="Face Amount"
      >
      </SelectBox>

      <SelectBox
        v-if="consumerBoxFlag()"
        :label="`Term Length`"
        :propsData="termLenghtData"
        boxName="Term Length"
      >
      </SelectBox>

      <SelectBox
        :propsData="responseMechanismData"
        boxName="Response Mechanism"
      />

      <SelectBox
        v-if="BankCreditComboFn()"
        :label="`Card Network`"
        :propsData="cardNetwork"
        boxName="Card Network"
      >
      </SelectBox>
      <DropdownList
        v-if="socialFlagOnNetworkName()"
        :data="networkName"
        boxName="Network Name"
      ></DropdownList>
      <DropdownList
        v-if="socialFlagOnNetworkName()"
        :data="socialMediaAdType"
        boxName="Social Media Ad Type"
      >
      </DropdownList>
    </div>
  </v-app>
</template>

<script>
import { ref, onMounted, watchEffect, computed, watch, inject } from "vue";
import SelectBox from "./reusable/SelectBox.vue";
import DropDownEvent from "./reusable/DropDownEvent.vue";
import { useStore } from "vuex";
import DropdownList from "./reusable/DropdownList.vue";
import VerticalSpacer from "./reusable/VerticalSpacer.vue";
// import MultiSelectObject from "./reusable/MultiSelectObject.vue";
// import RadioButton from "./reusable/RadioButton.vue";
// import RangeSlider from "./reusable/RangeSlider.vue";
import MinMaxSlider from "./priceRangeSlider.vue";
import CategorySelect from "./CategorySelect.vue";
import SubCategorySelect from "./SubCategorySelect.vue";
import SubSubCategorySelect from "./SubSubCategorySelect.vue";

export default {
  components: {
    SelectBox,
    DropDownEvent,
    DropdownList,
    VerticalSpacer,
    // RangeSlider,
    // MultiSelectObject,
    // RadioButton,
    MinMaxSlider,
    CategorySelect,
    SubCategorySelect,
    SubSubCategorySelect,
  },
  setup() {
    const store = useStore();
    const categoryList = ref([]);
    const FICOCreditVantage = ref([]);
    // const communicationTypes = ref(store.getters["Sector/getSectorCommData"]);
    const applicationType = ref([]);
    const IntroductoryPricing = [
      { id: 1, value: "Purch Intro" },
      { id: 2, value: "BT Intro" },
      { id: 3, value: "No Purch Intro" },
      { id: 4, value: "No BT Intro" },
    ];
    // const issueType = ["Any"];
    const energyEDC = ref([]);
    let energyRateType = ref([]);
    const energyOfferPrice = ref([]);
    const energyTerm = ref([]);
    const http = ref(inject("http"));
    // const personlizedOrNot = ref(3);
    const personalizedSelection = ref("3");
    const affinityCatDropdown = ref([]);
    const targetCountriesDropdown = [
      { id: 2, value: "African American" },
      { id: 4, value: "Asian" },
      { id: 5, value: "Asian-Indian" },
      { id: 11, value: "Baby Boomers" },
      { id: 10, value: "Gen Y/Millennial" },
      { id: 15, value: "Generation-X" },
      { id: 9, value: "High Net Worth" },
      { id: 3, value: "Hispanic" },
      { id: 6, value: "LGBTQ+" },
      { id: 12, value: "Middle Market" },
      { id: 13, value: "Military" },
      { id: 14, value: "Mover" },
      { id: 8, value: "Other" },
      { id: 16, value: "Silent Generation" },
      { id: 7, value: "Teen" },
      { id: 1, value: "Women" },
    ];
    const targetCountriesSelection = ref([]);
    const affinitySubCatDropdown = [
      { id: 23, value: "Political" },
      { id: 22, value: "Senior" },
      { id: 24, value: "Social" },
      { id: 25, value: "Sorority/Fraternity" },
      { id: 26, value: "Bank" },
      { id: 27, value: "Credit Union" },
      { id: 28, value: "Mortgage Companies" },
      { id: 30, value: "Accountant" },
      { id: 31, value: "Doctor" },
      { id: 32, value: "Engineer" },
      { id: 33, value: "Lawyer" },
      { id: 34, value: "Nurses" },
      { id: 35, value: "Teacher" },
      { id: 1, value: "Airline" },
      { id: 13, value: "Automotive" },
      { id: 29, value: "Cruise" },
      { id: 2, value: "Hotel/Resort" },
      { id: 36, value: "Other" },
      { id: 37, value: "Rental Cars" },
      { id: 38, value: "Timeshare" },
    ];
    const affinitySubCatSlicedDropdown = ref([]);
    const subsubCategory = ref([]);
    const preScreenOptOut = ref(false);
    const CDHPHDHPHSA = ref(false);
    const valueScore = ref(false);
    const subsubCategoryRole = ref(false);
    const responseMechanismData = ref([]);
    const ficoFieldRolebased = ref(false);
    const ficoRangeFieldRolebased = ref(false);
    const vantageScoreRolebased = ref(false);
    const vantageRangeRolebased = ref(false);
    const creditVisionRolebased = ref(false);
    const creditVisionRangeRolebased = ref(false);
    const affinionRoleVisibility = ref(false);
    const businessContentRoleVisibility = ref(false);
    const dmaRoleVisibility = ref(false);
    const electronic1RoleVisibility = ref(false);
    const electronicTypeRoleVisibility = ref(false);
    const is_hphsaRoleVisibility = ref(false);
    const prescriptionRoleVisibility = ref(false);
    const FeeProductRoleVisibility = ref(false);

    const RxRoleVisibility = ref(false);

    const responseMechanism2 = ref([]);
    const rewardCheckbox = ref(false);
    const subcategoryList = ref([]);
    const deliveryFlag = ref(false);
    const electronicTypeFlag = ref(false);
    const incentiveModel = ref(false);
    const prescriptionModel = ref(false);
    const is_affinionModel = ref(false);
    const correspondentLendingModel = ref(false);
    const usdaModel = ref(false);
    const faux_checkModel = ref(false);
    const is_prescreenModel = ref(false);
    const vaModel = ref(false);
    const conventionalModel = ref(false);
    const fhaModel = ref(false);
    const is_hphsaModel = ref(false);
    const jumbo_ncnfgModel = ref(false);
    const publicationTypeFlag = ref(false);
    const networkNameFlag = ref(false);
    const socialMediaAdTypeFlag = ref(false);
    const StateList = [];
    const deliveryMethod = ref();
    const affinityCatSelection = ref([]);
    const affinitySubCatSelection = ref([]);
    const rewardsProgVariable = ref([]);
    const mailingTypeData = ref([]);
    const businessContentData = ref([]);
    const dmaData = ref([]);
    const ageData = ref([]);
    const incomeData = ref([]);
    const IncomeProducingAssetsSegCodeData = ref([]);
    const valueScoreData = ref([]);
    // const faceAmntData = ref(
    //   store.getters["Sector/getsectorFaceAmtDataGett"].length === 0
    //     ? { fa_name: "Any" }
    //     : store.getters["Rawdata/getDropdownDataAPI"].faceamount
    // );
    const termLenghtData = ref();

    const faceAmntData = computed(() => {
      let faceget = store.getters["Sector/getsectorFaceAmtDataGett"];
      return faceget;
    });
    let issueType = ref([]);
    // const issueType = computed(() => {
    //   let faceget = store.getters["Rawdata/getDropdownDataAPI"].issue;
    //   return faceget.length === 0 ? { IssueTypeName: "Any" } : faceget;
    // });
    const publicationType = ref([]);

    const rewardProgBoxData = ref([]);
    const publicationName = ref("");
    const choosenpublicationName = ref(
      store.getters["Rawdata/setPublicationNameSelectedAction"]
    );
    const publicationNameloading = ref(false);
    const networkName = [
      { id: 0, value: "Any" },
      { id: "facebook.com", value: "Facebook" },
      { id: "instagram.com", value: "Instagram" },
      { id: "linkedin.com", value: "LinkedIn" },
      { id: "twitter.com", value: "Twitter" },
    ];

    const socialMediaAdType = ref([]);
    const cardNetwork = ref([]);

    const FicoScore = [
      { id: 1, value: 825 - 850 },
      { id: 1, value: 825 - 850 },
      { id: 1, value: 825 - 850 },
      { id: 1, value: 825 - 850 },
      { id: 1, value: 825 - 850 },
      { id: 1, value: 825 - 850 },
      { id: 1, value: 825 - 850 },
    ];
    const CreditVision = [
      { id: 1, value: 825 - 850 },
      { id: 1, value: 825 - 850 },
      { id: 1, value: 825 - 850 },
      { id: 1, value: 825 - 850 },
      { id: 1, value: 825 - 850 },
      { id: 1, value: 825 - 850 },
      { id: 1, value: 825 - 850 },
    ];
    const ancillary_product = ref([]);
    const usaStatesAPI = ref([]);
    const groupSizes = ref([]);
    const campaign_language = ref([
      { id: 0, key_id: "Select One", text_value: "Select One" },
    ]);
    const RealEstate = ["Real Estate Listings", "Real Estate Services"];
    const Retail = ["Any", "Apparel", "Appliance"];
    const Shipping = ["Express", "Frieght", "Express"];
    const printFlag = ref(store.getters["Rawdata/getselectBoxFlagGetters"]);
    const isCreditOptionOn = ref(false);
    const storeData = ref([]);
    const deliveryType = ref([]);
    const packageType = ref([]);
    const postage = ref([]);
    const preSorted = ref([]);
    const message = ref(null);
    const typing = ref(null);
    const debounce = ref(null);
    const electronicType = ref([]);
    const publicationNames = ref([]);
    // const ridersData = ref([{ ridersName: "Any" }]);
    const targetMarketCountriesBoxFlag = ref(false);
    const rewardProgBoxFlag = ref(false);
    const communicationType = ref([]);
    // store.getters["Rawdata/getDropdownDataAPI"].response_machanism
    onMounted(() => {
      storeData.value = store.getters["Rawdata/getDropdownDataAPI"];
      if (storeData.value) {
        ancillary_product.value = storeData.value.ancillary_product;
        // campaign_language.value = storeData.value.campaign_language;
        for (let i = 0; i < storeData.value.campaign_language.length; i++) {
          campaign_language.value.push(storeData.value.campaign_language[i]);
        }
        // console.log("campaign_language", campaign_language);
        const indexstates = storeData.value.states.map((item, index) => ({
          index,
          value: item,
        }));
        indexstates.sort((a, b) => a.value.stateID - b.value.stateID);
        const sortedPeople = indexstates.map((item) => item.value);
        usaStatesAPI.value = sortedPeople;
        groupSizes.value = storeData.value.group_size;
        socialMediaAdType.value = [
          { id: 0, text_value: "Any" },
          ...storeData.value.socialmedia_adtype,
        ];
        // console.log(socialMediaAdType.value, "DES");
        cardNetwork.value = storeData.value.card_type;
        mailingTypeData.value = storeData.value.mailing_type;
        businessContentData.value = storeData.value.business_content;
        ageData.value = storeData.value.age_group;
        incomeData.value = storeData.value.incometype;
        // termLenghtData.value = storeData.value.term_length;
        // const additinalRawData =
        //   store.getters["Rawdata/getRawAdditionalGetters"];
        // FICOCreditVantage.value = additinalRawData.FICO_CREDIT_VINTAGE.sort(
        //   (a, b) => b.id - a.id
        // );
        // publicationType.value = additinalRawData.publicationType.sort(
        //   (a, b) => a.print_typeSort - b.print_typeSort
        // );
        // rewardProgBoxData.value = additinalRawData.rewardProgBoxData;
        // energyOfferPrice.value = additinalRawData.energyOfferPrice;
        // applicationType.value = additinalRawData.applicationType.sort(
        //   (a, b) => a.ApplicationTypeSort - b.ApplicationTypeSort
        // );
        // affinityCatDropdown.value = additinalRawData.affinityCategory;
      }
    });

    function sortData(obj) {
      return obj.sort((a, b) =>
        a.AffinityCategoryName > b.AffinityCategoryName
          ? 1
          : b.AffinityCategoryName > a.AffinityCategoryName
          ? -1
          : 0
      );
    }
    watch(publicationName, (o) => {
      if (o.length > 1) {
        publicationNameloading.value = true;
        publicationNames.value = [];
        clearTimeout(debounce.value);
        debounce.value = setTimeout(() => {
          typing.value = null;
          message.value = o;

          fetch(`${http.value.master}publications/${o}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "eyJraWQiOiJxUytUWFFjcitCXC9mK3ZBdzJ2QWl4c1hqUVZPZFRVaURrM2RIQkVlZ1hNaz0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiI5NDI2N2NjNC02MDViLTRhMmItOTlhZi1mMDE5MDk3NTUyODYiLCJldmVudF9pZCI6IjU2YWJlMDkzLTJjYTgtNDA1Zi1iN2NkLWUxODM0YTBkMGEyYiIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE2ODg0NjA3MjQsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy13ZXN0LTIuYW1hem9uYXdzLmNvbVwvdXMtd2VzdC0yX2ZMWVVwdVBWZyIsImV4cCI6MTY4ODQ2MjUyNCwiaWF0IjoxNjg4NDYwNzI0LCJqdGkiOiIyNjhjMDY0Yy1lNWNhLTRhNTQtODQ2My0wZWIxOWY2MDEwNzIiLCJjbGllbnRfaWQiOiIyZzU0cWtxajNwbHRqcWN2ZDE4YmR2Z3F2MCIsInVzZXJuYW1lIjoiYXJ2aW5kbm1nIn0.efQRa1v2ZkzEL62JO9VEuQpglne1jXJ8SG70W-suPAag97NoCAkXAB2AXNGyMJ7AKiTdDRDbwKTFeVOkq2fJFJQ_RPfh7ZbijtQwrw1bvxcM17RyQXZaRKDQ_seSeDeg8pU3upUwBf7IgBP4OLPXRUNbNzmecIrnXkG9CRWeWoDx6AXDP8FzIMYBjWeb5birOBPGaAziltLt85SmCYui45Qwq4aZq9bev1J14TIYy2WWDwg2MaCMFiw5pTw7KpIfyUYMHBJ4T-qgpnqQmYRj-wbWj7Ljjg3HoRkBXJOjJS_lKedilLSIYjgVpPDQxxJEoGXz7-X7gYwAGXZNnG8W9g",
            },
          })
            .then((response) => {
              response.json().then((data) => {
                // console.log("111data", data);
                for (var i = 0; i < data?.length; i++) {
                  publicationNames.value.push({
                    id: data[i].publicationID,
                    name: data[i].publicationName,
                  });
                }
                publicationNameloading.value = false;
              });
            })
            .catch(function (e) {
              console.log(e);
            });
        }, 600);
      } else {
        publicationNames.value = [];
      }
    });

    watch(affinityCatSelection, (e) => {
      if (e !== undefined) {
        // console.log(e, " affcat");
        const affnityPayload = {
          values: e,
          label: "affinityCatSelection",
        };
        const searchCry = {
          val: e,
          column: "Affinity/Association Category",
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
        store.dispatch("Sector/setAffinityCategories", affnityPayload);
      }
    });
    watch(affinitySubCatSelection, (e) => {
      // console.log(e, " affsubcat");
      if (e !== undefined) {
        const affnityPayload = {
          values: e,
          label: "affinitySubCatSelection",
        };
        const searchCry = {
          val: e,
          column: "Affinity/Association Sub-Category",
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
        store.dispatch("Sector/setAffinityCategories", affnityPayload);
      }
    });
    watch(rewardsProgVariable, (e) => {
      // console.log("RWS", e, rewardProgBoxData.value);
      let reID = [];
      if (e.length == 1) {
        reID = e;
      } else {
        // console.log(e.length, " e len");
        for (let i = 0; i < e.length; i++) {
          // console.log(e[i].RewardTypeID, " e i ");
          reID[i] = e[i].RewardTypeID;
        }
      }

      const affnityPayload = {
        values: reID,
        label: "rewardsProgVariable",
      };
      const searchCry = {
        val: reID,
        column: "Rewards Program Emphasis",
        entirs: rewardProgBoxData.value,
      };
      // console.log(affnityPayload, "affnityPayload");
      // console.log(rewardsProgVariable.value, "re", rewardProgBoxData.value);
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      store.dispatch("Sector/setAffinityCategories", affnityPayload);
    });
    watchEffect(() => {
      // if (choosenpublicationName.value.length > 0) {
      //   console.log(choosenpublicationName.value, " 333");
      // }
      let userFields = store.getters["Rawdata/getuserRawDataGetter"];
      let excludeFields = store.getters["Rawdata/getUpdatedRawDataGetter"];
      if (Object.keys(userFields).length > 0) {
        // console.log(userFields, "userFields");

        //additional fields
        for (let i of Object.values(userFields.additional_fields)) {
          // console.log(i);
          if (i === "fico") {
            ficoFieldRolebased.value = true;
          } else if (i === "fico_range") {
            ficoRangeFieldRolebased.value = true;
          } else if (i === "vantage_score") {
            vantageScoreRolebased.value = true;
          } else if (i === "vantage_range") {
            vantageRangeRolebased.value = true;
          } else if (i === "credit_vision") {
            creditVisionRolebased.value = true;
          } else if (i === "credit_vision_range") {
            creditVisionRangeRolebased.value = true;
          }
        }
      }
      //exclude fields
      // console.log(excludeFields, "excludeFields");
      if (Object.keys(excludeFields).length > 0) {
        // console.log(excludeFields["excludenames"], "aaaa");
        let obj = excludeFields["excludenames"];
        // console.log(obj, "obj");
        if (obj !== undefined) {
          for (let i of Object.values(obj)) {
            // console.log(i.fieldName, 77777);
            if (i.fieldName === "affinion") {
              affinionRoleVisibility.value = true;
            } else if (i.fieldName === "businessContent") {
              businessContentRoleVisibility.value = true;
            } else if (i.fieldName === "DMA_CODE") {
              dmaRoleVisibility.value = true;
            } else if (i.fieldName === "electronicID") {
              electronic1RoleVisibility.value = true;
            } else if (i.fieldName === "is_hphsa") {
              is_hphsaRoleVisibility.value = true;
            } else if (i.fieldName === "prescription") {
              prescriptionRoleVisibility.value = true;
            } else if (i.fieldName === "Fee Product") {
              FeeProductRoleVisibility.value = true;
            } else if (i.fieldName === "Pre-Screen/Opt-Out") {
              preScreenOptOut.value = true;
            } else if (i.fieldName === "CDHP/HDHP/HSA") {
              CDHPHDHPHSA.value = true;
            } else if (i.fieldName === "Value Score") {
              valueScore.value = true;
            } else if (i.fieldName === "Sub Sub Category") {
              subsubCategoryRole.value = true;
            } else if (i.fieldName === "Rx") {
              RxRoleVisibility.value = true;
            } else if (i.fieldName === "Electronic Type") {
              electronicTypeRoleVisibility.value = true;
            }
          }
        }
      }
      let lastSearch = store.getters["Media/getAdditionalSelectedDataGetters"];
      let keys = Object.keys(lastSearch);
      // console.log(keys, " keys");
      if (Object.keys(lastSearch).length > 0) {
        // console.log(lastSearch, "lastSearch");
        if (["AffinityCategoryID_mult"]?.length > 0) {
          affinityCatSelection.value = lastSearch["AffinityCategoryID_mult"];
        }
        if (lastSearch["AffinitySubCategoryID_mult"]?.length > 0) {
          affinitySubCatSelection.value =
            lastSearch["AffinitySubCategoryID_mult"];
        }
        if (keys.includes("is_incentive")) {
          if (lastSearch["is_incentive"][0] === 1) {
            incentiveModel.value = true;
            const checkedPayloads = {
              value: incentiveModel.value,
              status: false,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
        }
        if (keys.includes("prescription")) {
          if (lastSearch["prescription"][0] === 1) {
            prescriptionModel.value = true;
            const checkedPayloads = {
              value: prescriptionModel.value,
              status: false,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
        }
        if (keys.includes("is_affinion")) {
          if (lastSearch["is_affinion"][0] === 1) {
            is_affinionModel.value = true;
            const checkedPayloads = {
              value: is_affinionModel.value,
              status: false,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
        }
        if (keys.includes("correspondent_lending")) {
          if (lastSearch["correspondent_lending"][0] === 1) {
            correspondentLendingModel.value = true;
            const checkedPayloads = {
              value: correspondentLendingModel.value,
              status: false,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
        }
        if (keys.includes("conventional")) {
          if (lastSearch["conventional"][0] === 1) {
            conventionalModel.value = true;
            const checkedPayloads = {
              value: conventionalModel.value,
              status: false,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
        }
        if (keys.includes("fha")) {
          if (lastSearch["fha"][0] === 1) {
            fhaModel.value = true;
            const checkedPayloads = {
              value: fhaModel.value,
              status: false,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
        }
        if (keys.includes("is_hphsa")) {
          if (lastSearch["is_hphsa"][0] === 1) {
            is_hphsaModel.value = true;
            const checkedPayloads = {
              value: is_hphsaModel.value,
              status: false,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
        }
        if (keys.includes("jumbo_ncnfg")) {
          if (lastSearch["jumbo_ncnfg"][0] === 1) {
            jumbo_ncnfgModel.value = true;
            const checkedPayloads = {
              value: jumbo_ncnfgModel.value,
              status: false,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
        }
        if (keys.includes("usda")) {
          if (lastSearch["usda"][0] === 1) {
            usdaModel.value = true;
            const checkedPayloads = {
              value: usdaModel.value,
              status: false,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
        }
        if (keys.includes("faux_check")) {
          if (lastSearch["faux_check"][0] === 1) {
            faux_checkModel.value = true;
            const checkedPayloads = {
              value: faux_checkModel.value,
              status: false,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
        }
        if (keys.includes("is_prescreen")) {
          if (lastSearch["is_prescreen"][0] === 1) {
            is_prescreenModel.value = true;
            const checkedPayloads = {
              value: is_prescreenModel.value,
              status: false,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
        }
        if (keys.includes("va")) {
          if (lastSearch["va"][0] === 1) {
            vaModel.value = true;
            const checkedPayloads = {
              value: vaModel.value,
              status: false,
            };
            store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
          }
        }
      }

      if (
        store.getters["Rawdata/getPublicationNameSelectedGetters"].length > 0
      ) {
        choosenpublicationName.value =
          store.getters["Rawdata/getPublicationNameSelectedGetters"];
      }

      if (storeData.value) {
        deliveryMethod.value = storeData.value.delivery_method;
        deliveryType.value = storeData.value.delivery_type;
        postage.value = storeData.value.postage_type;
        packageType.value = storeData.value.package_type;
        preSorted.value = storeData.value.presorted_type;
        electronicType.value = storeData.value.electronic_type;
      }
      const sector = store.getters["Rawdata/getsectorAPIPayloadGetters"];
      if (sector.length > 0) {
        responseMechanismData.value =
          store.getters["Sector/getresponseMechanismAPIGett"];
      } else {
        store.dispatch("Sector/setresponseMechanismAPIAction", null);
        responseMechanismData.value = [];
      }
      communicationType.value = store.getters["Sector/getSectorCommData"];
      // console.log("responseMechanismData....", responseMechanismData.value);
      energyRateType.value = store.getters["Sector/getEnergyRateType"];
      dmaData.value = store.getters["Sector/getdropDownDataDma"];
      const energyEdc = store.getters["Sector/getdropDownDataCscanEdc"];
      energyEdc.sort(function (a, b) {
        if (a.edc_name < b.edc_name) {
          return -1;
        }
        if (a.edc_name > b.edc_name) {
          return 1;
        }
        return 0;
      });
      // console.log("SWWS", energyEdc);
      energyEDC.value = energyEdc;
      IncomeProducingAssetsSegCodeData.value =
        store.getters["Sector/getdropDownDataIncomeProducing"];
      termLenghtData.value = store.getters["Sector/getTermLength"];
      valueScoreData.value =
        store.getters["Sector/getdropDownDataScoreHousehold"];
      energyTerm.value = store.getters["Sector/getdropDownDataEtermLength"];
      // console.log(
      //   store.getters["Audience/getConsumerEmpBoxesFlagGetters"],
      //   "getttt"
      // );
      const category = store.getters["Sector/getcategoryPayload"];
      if (category.cat_.includes(13)) {
        let faceget = store.getters["Rawdata/getDropdownDataAPI"].issue;
        issueType.value = faceget;
        // if (issueType.value.length === 0) {
        //   for (let i = 0; i < faceget.length; i++) {
        //     issueType.value.push(faceget[i].IssueTypeName);
        //   }
        // }

        // faceget.length === 0 ? { issueType.push() IssueTypeName: "Any" } : faceget;
      } else {
        // issueType.value.push({ IssueTypeName: "Any" });
        issueType.value = [];
        store.dispatch("Rawdata/setissueTypePayloadAction", null);
      }

      if (!store.getters["Audience/getConsumerEmpBoxesFlagGetters"]) {
        store.dispatch("Sector/setSiDropDownPayload", {
          boxname: "delete_consumer_box",
        });
      }
      if (!store.getters["Sector/getInsuranceBoxFlagGetters"]) {
        store.dispatch("Sector/setSiDropDownPayload", {
          boxname: "delete_insurance_box",
        });
      }
      if (!store.getters["Sector/getCreditComboBoxesGetters"]) {
        store.dispatch("Sector/setSiDropDownPayload", {
          boxname: "delete_credit_combo",
        });
        store.dispatch("Rawdata/setintroductoryPricingPayloadAction", []);
      }
      if (
        !store.getters["Audience/getInsuranceBoxFlagGetters"] &&
        !store.getters["Audience/getConsumerEmpBoxesFlagGetters"]
      ) {
        store.dispatch("Sector/setSiDropDownPayload", {
          boxname: "delete_audit_insurance",
        });
      }
      if (!store.getters["Sector/getMortageSelectedGett"]) {
        store.dispatch("Sector/setCheckboxPayload", {
          value: "delete_mortage_selected",
        });
      }
      if (!store.getters["Sector/getTravelRetailBoxFlagGetters"]) {
        store.dispatch("Sector/setCheckboxPayload", {
          value: "delete_travel_retailbox_flaghandler",
        });
      }
      if (!store.getters["Sector/getBankCreditGetters"]) {
        store.dispatch("Sector/setCheckboxPayload", {
          value: "delete_credit_card",
        });
      }
      // console.log("CCCCC.", store.getters["Sector/getInsuranceBoxFlagGetters"]);
      if (!store.getters["Sector/getInsuranceBoxFlagGetters"]) {
        store.dispatch("Sector/setCheckboxPayload", {
          value: "delete_insurance",
        });
      }
      if (
        !store.getters["Sector/getBankCreditGetters"] &&
        !store.getters["Sector/getBankingCardGetters"]
      ) {
        store.dispatch("Sector/setCheckboxPayload", {
          value: "delete_rewards",
        });
      }
      let checkboxSelected =
        store.getters["Media/getAdditionalSelectedDataGetters"];
      // console.log(checkboxSelected, " checkboxSelected");
      if (
        Object.keys(checkboxSelected).length > 0 &&
        checkboxSelected !== undefined
      ) {
        if (checkboxSelected["RewardsProgramEmphasis_mult"]) {
          // console.log(checkboxSelected["RewardsProgramEmphasis_mult"], 333);
          // rewardsProgVariable.value = true;
          // rewardProgBoxFlag.value = true;
          // console.log(
          //   rewardCheckbox.value,
          //   "checkedPayloads1",
          //   rewardProgBoxFlag.value
          // );
          // console.log(" cr", store.getters["Sector/getBankCreditGetters"]);
          // console.log(" cr", store.getters["Sector/getBankingCardGetters"]);
          // rewardCheckbox.value = true;
          if (!rewardCheckbox.value) {
            rewardsBoxHandler();
            rewardsProgVariable.value =
              checkboxSelected["RewardsProgramEmphasis_mult"];
          }
        }

        // console.log(rewardsProgVariable.value, "rewardsProgVariable");
        // console.log(rewardCheckbox.value, "re checkbox");
      }
    });
    function removepublicationName(c) {
      choosenpublicationName.value = choosenpublicationName.value.filter(
        (o) => c.id !== o.id
      );
      if (publicationNames.value.length > 0) {
        publicationNames.value.unshift(c);
      }
      store.dispatch(
        "Rawdata/setPublicationNameSelectedAction",
        choosenpublicationName.value
      );
      store.dispatch(
        "Rawdata/setPublicationNamePayloadAction",
        choosenpublicationName.value
      );
      const multiPay = {
        event: "Publication Name",
        value: choosenpublicationName.value,
      };
      store.dispatch("Rawdata/setSearchCriteriaMultiTextboxes", multiPay);
    }
    function ridersData() {
      let storeRider = store.getters["Sector/getsectorIdRiders"];
      return storeRider.length === 0 ? [] : storeRider;
    }
    function offerOriginData() {
      let media = store.getters["Rawdata/getmediaAPIPayloadGetters"];
      let sector = store.getters["Rawdata/getsectorAPIPayloadGetters"];
      let audience = store.getters["Rawdata/getaudienceAPIPayloadGetters"];
      let storeOfferData = JSON.parse(
        JSON.stringify(store.getters["Sector/getOfferOrigin"])
      );
      let storeOfferOrigin = [{ oo_name: "Select One" }];
      storeOfferOrigin = storeOfferOrigin.concat(storeOfferData);
      // console.log(storeOfferData, "off");
      // console.log(storeOfferOrigin, "storeOfferOrigin");
      if (
        Object.keys(media).length > 0 &&
        Object.keys(sector).length > 0 &&
        Object.keys(audience).length > 0
      ) {
        return storeOfferOrigin === undefined
          ? [{ oo_name: "Select One" }]
          : storeOfferOrigin;
      } else {
        return [{ oo_name: "Select One" }];
      }
    }

    // function faceAmntData() {
    //   let face = store.getters["Sector/setSectorFaceAmtData"];
    //   return face.length === 0 ? [{ fa_name: "Any" }] : face;
    // }

    function PersonalizedFlag() {
      return store.getters["Audience/getpersonalizedFlagGetters"];
    }

    function consumerBoxFlag() {
      // console.log(
      //   "cons",
      //   store.getters["Audience/getConsumerEmpBoxesFlagGetters"]
      // );
      return store.getters["Audience/getConsumerEmpBoxesFlagGetters"];
    }

    function mailingBoxFlag() {
      // let insuranceBox = store.getters["Sector/getInsuranceBoxFlagGetters"];
      // let consEmpBox = store.getters["Audience/getConsumerEmpBoxesFlagGetters"];
      return store.getters["Audience/getConsumerEmpBoxesFlagGetters"];
      // return insuranceBox ? insuranceBox : consEmpBox;
    }

    function investmentBoxFlag() {
      return store.getters["Sector/getInvestmentBoxFlagGetters"];
    }
    function insuranceBoxFlag() {
      return (
        store.getters["Sector/getInsuranceBoxFlagGetters"] ||
        store.getters["Sector/getInvestmentBoxFlagGetters"]
      );
    }
    function audianceInsuranceBoxFlag() {
      return store.getters["Audience/getInsuranceBoxFlagGetters"];
    }
    function ifMortageSelected() {
      return store.getters["Sector/getMortageSelectedGett"];
    }

    function deliveryFlagOnDirect() {
      // console.log(
      //   "del",
      //   store.getters["Rawdata/getDeliveryDirectMailFlagGetters"]
      // );
      let status = false;
      if (store.getters["Media/getDeliveryDirectMailFlagGetters"]) {
        status = true;
      } else {
        store.dispatch("Sector/setDeliveryMethodId", []);
        status = false;
      }

      // return store.getters["Rawdata/getDeliveryDirectMailFlagGetters"];
      return status;
    }

    function publicationNameclickedOut() {
      publicationNames.value = [];
      publicationName.value = "";
    }

    function clearpublicationNameLookupUserEntry() {
      publicationName.value = "";
    }

    function clearpublicationNameLookupAllEntry() {
      publicationName.value = "";
      publicationNames.value = [];
      choosenpublicationName.value = [];
      store.dispatch(
        "Rawdata/setPublicationNamePayloadAction",
        choosenpublicationName.value
      );
      store.dispatch(
        "Rawdata/setPublicationNameSelectedAction",
        choosenpublicationName.value
      );
      const multiPay = {
        event: "Publication Name",
        value: choosenpublicationName.value,
      };
      store.dispatch("Rawdata/setSearchCriteriaMultiTextboxes", multiPay);
    }

    function publicationNameSelectAll() {
      choosenpublicationName.value = publicationNames.value;
      store.dispatch(
        "Rawdata/setPublicationNamePayloadAction",
        choosenpublicationName.value
      );
      store.dispatch(
        "Rawdata/setPublicationNameSelectedAction",
        choosenpublicationName.value
      );
      const multiPay = {
        event: "Publication Name",
        value: choosenpublicationName.value,
      };
      store.dispatch("Rawdata/setSearchCriteriaMultiTextboxes", multiPay);
    }
    function publicationNameShowAll() {
      publicationName.value = "";
    }

    function choosepublicationName(c) {
      // console.log(c, "c");
      // console.log(c.id, "c");
      // console.log(c[0].id, "c");
      let is_company = choosenpublicationName.value.filter(
        (o) => c.id === o.id
      );
      if (Array.isArray(is_company)) {
        if (is_company.length === 0) {
          choosenpublicationName.value.push(c);
          publicationNames.value = publicationNames.value.filter(
            (o) => c.id !== o.id
          );
        }
      }
      store.dispatch(
        "Rawdata/setPublicationNamePayloadAction",
        choosenpublicationName.value
      );
      const multiPay = {
        event: "Publication Name",
        value: choosenpublicationName.value,
      };
      console.log(choosenpublicationName.value, "choosenpublicationName.value");
      store.dispatch("Rawdata/setSearchCriteriaMultiTextboxes", multiPay);
    }
    function affinityClickHandler1() {
      affinitySubCatSlicedDropdown.value = [];
      const additinalRawData =
        store.getters["Rawdata/getRawAdditionalGetters"].affinitySubCategory;
      for (let i = 0; i < additinalRawData.length; i++) {
        for (let j = 0; j < affinityCatSelection.value.length; j++) {
          if (
            affinityCatSelection.value[j].AffinityCategoryID ===
            additinalRawData[i].parentID
          ) {
            affinitySubCatSlicedDropdown.value.push(additinalRawData[i]);
            // console.log("Clear afinity", affinityCatSelection.value.length);
          }
        }
      }
      if (affinityCatSelection.value.length === 0) {
        affinitySubCatSelection.value = [];
      }
    }
    function affinityClickHandler() {
      affinitySubCatSlicedDropdown.value = [];
      // console.log(e);
      // console.log(affinityCatSelection.value);
      // let len = affinityCatSelection.value.length;
      if (affinityCatSelection.value.length === 0) {
        affinitySubCatSlicedDropdown.value = [];
      } else {
        for (const a in affinityCatSelection.value) {
          // console.log(affinityCatSelection.value, "p");
          if (
            affinityCatSelection.value[a].value === "Any" ||
            affinityCatSelection.value[a].value === "Club/Association" ||
            affinityCatSelection.value[a].value === "Fraternal Order" ||
            affinityCatSelection.value[a].value === "Government/Military" ||
            affinityCatSelection.value[a].value === "Petroleum" ||
            affinityCatSelection.value[a].value === "Publishing" ||
            affinityCatSelection.value[a].value === "Retail" ||
            affinityCatSelection.value[a].value === "Sports Team" ||
            affinityCatSelection.value[a].value === "Union" ||
            affinityCatSelection.value[a].value === "Other"
          ) {
            let ind = affinitySubCatSlicedDropdown.value.findIndex(
              (f) => f.value === "Any"
            );
            // console.log(ind, "ind");
            if (ind >= 0) {
              affinitySubCatSlicedDropdown.value.splice(ind, 1);
            }
            // console.log(
            //   affinitySubCatSlicedDropdown.value,
            //   "affinitySubCatSlicedDropdown"
            // );
            for (const b in affinitySubCatDropdown) {
              if (affinitySubCatDropdown[b].id === 0)
                // console.log(affinitySubCatDropdown.value[b], 8);
                affinitySubCatSlicedDropdown.value.push(
                  affinitySubCatDropdown[b]
                );
            }
            // affinitySubCatSlicedDropdown.value.push({ id: 0, value: "Any" });
          } else if (affinityCatSelection.value[a].value === "Advocacy") {
            for (const b in affinitySubCatDropdown) {
              if (
                affinitySubCatDropdown[b].id === 22 ||
                affinitySubCatDropdown[b].id === 23 ||
                affinitySubCatDropdown[b].id === 24
              )
                // console.log(affinitySubCatDropdown.value[b], 8);
                affinitySubCatSlicedDropdown.value.push(
                  affinitySubCatDropdown[b]
                );
            }
          } else if (
            affinityCatSelection.value[a].value === "Alumni/University"
          ) {
            for (const b in affinitySubCatDropdown) {
              if (affinitySubCatDropdown[b].id === 25)
                affinitySubCatSlicedDropdown.value.push(
                  affinitySubCatDropdown[b]
                );
            }
          } else if (
            affinityCatSelection.value[a].value === "Financial Institution"
          ) {
            for (const b in affinitySubCatDropdown) {
              if (
                affinitySubCatDropdown[b].id === 26 ||
                affinitySubCatDropdown[b].id === 27 ||
                affinitySubCatDropdown[b].id === 28
              )
                affinitySubCatSlicedDropdown.value.push(
                  affinitySubCatDropdown[b]
                );
            }
          } else if (affinityCatSelection.value[a].value === "Professional") {
            for (const b in affinitySubCatDropdown) {
              if (
                affinitySubCatDropdown[b].id === 30 ||
                affinitySubCatDropdown[b].id === 31 ||
                affinitySubCatDropdown[b].id === 32 ||
                affinitySubCatDropdown[b].id === 33 ||
                affinitySubCatDropdown[b].id === 34 ||
                affinitySubCatDropdown[b].id === 35
              )
                affinitySubCatSlicedDropdown.value.push(
                  affinitySubCatDropdown[b]
                );
            }
          } else if (affinityCatSelection.value[a].value === "Travel") {
            for (const b in affinitySubCatDropdown) {
              if (
                affinitySubCatDropdown[b].id === 1 ||
                affinitySubCatDropdown[b].id === 13 ||
                affinitySubCatDropdown[b].id === 29 ||
                affinitySubCatDropdown[b].id === 2 ||
                affinitySubCatDropdown[b].id === 36 ||
                affinitySubCatDropdown[b].id === 37 ||
                affinitySubCatDropdown[b].id === 38
              )
                affinitySubCatSlicedDropdown.value.push(
                  affinitySubCatDropdown[b]
                );
            }
          }
        }
      }
      // console.log(affinitySubCatSlicedDropdown.value, 9);
    }

    function targetMarketHandler() {
      if (targetMarketCountriesBoxFlag.value) {
        store.dispatch("Sector/setTargetIDs", []);
      }
      targetMarketCountriesBoxFlag.value = !targetMarketCountriesBoxFlag.value;
    }

    function rewardsBoxHandler(e) {
      // console.log(e, 1222);
      let check = "";
      let val = "";
      if (e !== undefined) {
        rewardCheckbox.value = e.target.checked ? true : true;
        check = e.target.checked ? true : true;
        val = e.target.value ? "true" : "true";
      } else {
        check = true;
        rewardCheckbox.value = check;
        val = "Rewards";
      }
      // console.log(e.target.value, 222222222222, e.target.checked);
      // console.log(rewardCheckbox.value, "rewardCheckbox");
      const checkedPayloads = {
        value: val,
        status: check,
      };
      // console.log(checkedPayloads, "start checkedPayloads");
      store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
      const rewardPayload = {
        values: "",
        label: "rewardsProgVariable",
      };
      store.dispatch("Sector/setAffinityCategories", rewardPayload);
      rewardProgBoxFlag.value = !rewardProgBoxFlag.value;
      // console.log(rewardPayload, "rewardPayload");
    }

    function communicationTypes() {
      return store.getters["Sector/getSectorCommData"]
        ? store.getters["Sector/getSectorCommData"]
        : ["Any"];
    }
    function dashboardDirectComboFn() {
      // console.log("del", store.getters["Rawdata/getselectBoxFlagGetters"]);
      let status = false;
      if (store.getters["Media/getDashboardDirectMailOptionBoxFlagGetters"]) {
        status = true;
      } else {
        status = false;
      }

      // return store.getters["Rawdata/getDeliveryDirectMailFlagGetters"];
      return status;
    }

    function dashboardDirectEmailComboFn() {
      // console.log("del", store.getters["Rawdata/getselectBoxFlagGetters"]);
      let status = false;
      if (
        store.getters["Media/getDashboardDirectMailEmailOptionBoxFlagGetters"]
      ) {
        status = true;
      } else {
        status = false;
      }

      // return store.getters["Rawdata/getDeliveryDirectMailFlagGetters"];
      return status;
    }
    function categoryFnHandler() {
      let temp = store.getters["Sector/getcategorySector"];
      // console.log(temp, "temp");
      if (temp) {
        categoryList.value = temp;
        // console.log("get", temp[0].sectorName);
      }
    }

    function BankCreditComboFn() {
      return store.getters["Sector/getBankingCardGetters"];
    }

    function CreditComboFn() {
      return store.getters["Sector/getCreditComboBoxesGetters"];
    }

    function subCategoryFnHandler() {
      let temp = store.getters["Sector/getSubCategoryGetters"];
      // console.log("temppp", temp);
      if (temp) {
        subcategoryList.value = temp;
        // console.log("get", subcategoryList.value);
      }
    }

    function subsubCategoryFnHandler() {
      let temp = store.getters["Sector/getSubSubCategoryGetters"];
      // console.log("temppp", temp);
      if (temp) {
        subsubCategory.value = temp;
        // console.log("get", subsubCategory.value);
      }
    }

    function bankingOptionFlagOn() {
      let status = false;
      if (store.getters["Media/getBankingOptionBoxFlagGetters"]) {
        status = true;
      } else {
        status = false;
      }
      return status;
    }

    function creditOptionFlagOn() {
      let status = false;
      if (store.getters["Sector/getBankCreditGetters"]) {
        status = true;
      } else {
        status = false;
      }
      return status;
    }

    function electronicTypeFlagOnEmail() {
      let status;
      if (store.getters["Media/getEmailElectronicTypeBoxFlagGetters"]) {
        status = true;
        // store.dispatch("Media/setDashboardDirectMailBoxFlagAction", true);
      } else {
        status = false;
        // store.dispatch("Rawdata/setelectronicTypePayloadAction", []);
      }
      return status;

      // console.log(
      //   "emai",
      //   store.getters["Rawdata/getEmailElectronicTypeBoxFlagGetters"]
      // );
      // return store.getters["Rawdata/getEmailElectronicTypeBoxFlagGetters"];
    }

    function affinityBoxHandler() {
      return store.getters["Rawdata/getAffinityBoxesGetters"];
    }

    function publicationTypeFlagOnPrint() {
      let status = false;
      if (store.getters["Media/getprintPublicationTypeBoxFlagGetters"]) {
        status = true;
      } else {
        status = false;
        store.dispatch("Rawdata/setPublicationTypePayloadAction", []);
      }
      return status;

      // console.log(
      //   "pub",
      //   store.getters["Rawdata/getprintPublicationTypeBoxFlagGetters"]
      // );
      // return store.getters["Rawdata/getprintPublicationTypeBoxFlagGetters"];
    }

    function convertSelectToJson(e) {
      // console.log(
      //   e.target.checked,
      //   "cnvrtaaa e",
      //   e.srcElement.labels[0].innerText
      // );
      const checkedPayloads = {
        value: e.srcElement.labels[0].innerText,
        status: e.target.checked,
      };
      // console.log(checkedPayloads, " checkedPayloads");
      if (e.target.value === "Affinity/Association") {
        affinityCatSelection.value = [];
        affinitySubCatSelection.value = [];
      }
      store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
    }
    function energyCheckboxex(e) {
      const checkedPayloads = {
        boxname: e.target.value,
        status: e.target.checked,
      };
      store.dispatch("Sector/setEnergySetPayload", checkedPayloads);
    }

    function TravelRetailBoxFlagHandler() {
      return store.getters["Sector/getTravelRetailBoxFlagGetters"];
    }
    function ifEnergySelected() {
      // console.log(30, store.getters["Sector/getenergyBoxesFlag"]);
      // EdcDataFetch();
      if (!store.getters["Sector/getenergyBoxesFlag"]) {
        store.dispatch("Sector/setEnergySetPayload", "none");
      }

      return store.getters["Sector/getenergyBoxesFlag"];
    }

    function EdcDataFetch() {
      fetch(`${http.value.cscanDmaCode}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }).then((response) => {
        response.json().then(async (data) => {
          console.log(data);
          // sector = await resolveAfter2Seconds();
          energyEDC.value = data.data;
        });
      });
    }
    function socialFlagOnNetworkName() {
      let status = false;
      if (store.getters["Media/getsocialNetworkNameBoxFlagGetters"]) {
        status = true;
      } else {
        status = false;
      }
      return status;

      // console.log(
      //   "prin",
      //   store.getters["Rawdata/getprintPublicationTypeBoxFlagGetters"]
      // );
      // return store.getters["Rawdata/getprintPublicationTypeBoxFlagGetters"];
    }
    function dropsEventsChanges(e) {
      // console.log(e, " 4444e");
      const checkedPayloads = {
        value: e,
        status: false,
      };
      // console.log(checkedPayloads, "checkedPayloads");
      store.dispatch("Sector/setCheckboxPayload", checkedPayloads);
    }

    function updateRadioValues() {
      // console.log(personalizedSelection.value, 33);
      if (
        Number(personalizedSelection.value) === 1 ||
        Number(personalizedSelection.value) === 2
      ) {
        store.dispatch(
          "Rawdata/setpersonalizedRadiosAction",
          personalizedSelection.value
        );
      } else {
        store.dispatch("Rawdata/setpersonalizedRadiosAction", null);
      }
    }

    return {
      affinityClickHandler1,
      audianceInsuranceBoxFlag,
      updateRadioValues,
      convertSelectToJson,
      energyCheckboxex,
      socialFlagOnNetworkName,
      cardNetwork,
      electronicTypeFlagOnEmail,
      publicationTypeFlagOnPrint,
      subsubCategory,
      subcategoryList,
      StateList,
      FicoScore,
      insuranceBoxFlag,
      energyEDC,
      incentiveModel,
      faux_checkModel,
      prescriptionModel,
      bankingOptionFlagOn,
      dashboardDirectComboFn,
      dashboardDirectEmailComboFn,
      creditOptionFlagOn,
      CreditVision,
      rewardCheckbox,
      responseMechanismData,
      responseMechanism2,
      ifMortageSelected,
      printFlag,
      categoryFnHandler,
      campaign_language,
      ancillary_product,
      preSorted,
      socialMediaAdType,
      networkName,
      isCreditOptionOn,
      ridersData,
      communicationTypes,
      communicationType,
      affinityBoxHandler,
      publicationType,
      applicationType,
      IntroductoryPricing,
      issueType,
      electronicType,
      usaStatesAPI,
      groupSizes,
      RealEstate,
      Retail,
      Shipping,
      affinityClickHandler,
      FICOCreditVantage,
      ifEnergySelected,
      investmentBoxFlag,
      deliveryMethod,
      preScreenOptOut,
      RxRoleVisibility,
      targetMarketHandler,
      CDHPHDHPHSA,
      subsubCategoryRole,
      valueScore,
      deliveryFlag,
      electronicTypeFlag,
      publicationTypeFlag,
      networkNameFlag,
      socialMediaAdTypeFlag,
      deliveryFlagOnDirect,
      affinityCatDropdown,
      categoryList,
      subCategoryFnHandler,
      postage,
      packageType,
      deliveryType,
      BankCreditComboFn,
      CreditComboFn,
      energyRateType,
      energyOfferPrice,
      energyTerm,
      consumerBoxFlag,
      PersonalizedFlag,
      mailingBoxFlag,
      targetMarketCountriesBoxFlag,
      mailingTypeData,
      businessContentData,
      affinityCatSelection,
      affinitySubCatSelection,
      rewardProgBoxData,
      rewardsBoxHandler,
      rewardProgBoxFlag,
      dmaData,
      ageData,
      incomeData,
      IncomeProducingAssetsSegCodeData,
      valueScoreData,
      faceAmntData,
      termLenghtData,
      affinitySubCatDropdown,
      affinitySubCatSlicedDropdown,
      targetCountriesDropdown,
      targetCountriesSelection,
      subsubCategoryFnHandler,
      TravelRetailBoxFlagHandler,
      offerOriginData,
      choosepublicationName,
      publicationNames,
      publicationNameloading,
      publicationName,
      removepublicationName,
      publicationNameclickedOut,
      clearpublicationNameLookupUserEntry,
      clearpublicationNameLookupAllEntry,
      publicationNameSelectAll,
      publicationNameShowAll,
      choosenpublicationName,
      message,
      typing,
      debounce,
      EdcDataFetch,
      dropsEventsChanges,
      personalizedSelection,
      rewardsProgVariable,
      sortData,
      vaModel,
      conventionalModel,
      usdaModel,
      is_affinionModel,
      is_hphsaModel,
      jumbo_ncnfgModel,
      fhaModel,
      // personlizedOrNot
      is_prescreenModel,
      correspondentLendingModel,
      ficoFieldRolebased,
      ficoRangeFieldRolebased,
      vantageScoreRolebased,
      vantageRangeRolebased,
      creditVisionRolebased,
      creditVisionRangeRolebased,
      affinionRoleVisibility,
      businessContentRoleVisibility,
      dmaRoleVisibility,
      electronic1RoleVisibility,
      is_hphsaRoleVisibility,
      prescriptionRoleVisibility,
      FeeProductRoleVisibility,
      electronicTypeRoleVisibility,
    };
  },
};
</script>

<style>
.v-selection-control .v-label {
  width: auto !important;
}

/* .v-label {
  font-size: 12px;
  font-family: "Open Sans", sans-serif;
} */
</style>
